import React, { useState, useEffect, useLayoutEffect } from "react";

import { Typography } from "@mui/material";
import { IoChevronBack } from "react-icons/io5";
// reusable
import SongCard from "../../../components/reusable/SongCard";
import { useNavbar } from "../../../context/NavBarContext";
import MusicDetailLoading from "../../../components/skeletonLoading/detailLoading/MusicDetailLoading";

import { useFetchDetailDataQuery } from "../../../api/homepageApi";
import { useParams } from "react-router";

import { NotFound } from "../../error/NotFound_404";
import { useMusic } from "../../../context/MusicContext";
// const AlbumDetail = ({ data }) => {
const AlbumDetail = () => {
  const musicContext = useMusic();
  const [isInitialMount, setIsInitialMount] = useState(true);
  const [options, setOptions] = useState({
    url: "",
    body: {},
  });

  // navbar context
  const Navbar = useNavbar();
  const { id } = useParams();

  const { data, error, isLoading, isFetching } = useFetchDetailDataQuery(options , {
    skip: isInitialMount,
  });

  useEffect(() => {
    if(data) {
      let copyData = data.result.filter((music) => music.can_play == 1);
      musicContext.setDummyPlayList(copyData);
    }
  }, [data]);

  useEffect(() => {
    const updateOptions = () => {
      setOptions(() => ({
        url: `/music/album/detail`,
        body: {
          'album_id': id,
        },
      }));
    };

    updateOptions();
    setIsInitialMount(false);
    // Navbar.setLogoPlace(data.result.title);
  }, []);

  useLayoutEffect(() => {
    Navbar.setTogglePlace(<IoChevronBack fontSize="20" />);
  }, [])

  if(isLoading) {
    return <MusicDetailLoading />
  }

  if (error) {
    return <NotFound error={error} />
  }

  return (
    <>
      {data ? (
        <div className="relative rounded-lg h-50">
        <img
          src={data.image}
          alt="image"
          className="rounded-lg w-full h-full object-cover blur-md"
        />
        <div className="absolute inset-0 top-1/4 left-1/4  w-1/2 h-1/2 flex flex-col items-center justify-center">
          <img
            src={data.image}
            alt="image"
            className="rounded-lg object-cover "
          />
          <Typography variant="h6" fontWeight={"bold"} className={"text-white self-center"}>
            {data.title}
          </Typography>
        </div>
      </div>
      ): ""}
      {data?.result.map((item, index) => (
        <SongCard key={item.id} item={item} />
      ))}
    </>
  );
};

export default AlbumDetail;
